type Result = { is_successful: true } | { is_successful: false; reason: string };

export function validateRoute(route, token, day): Result {
    if (!route?.dailyRoutes?.length) 
        return { 
            is_successful: false, 
            reason: 'No hay ruta generada' 
        };

    if (!token) 
        return { 
            is_successful: false, 
            reason: 'Token no disponible' 
        };

    const dayIndex = (Number(day) || 0) - 1;
    if (dayIndex < 0 || dayIndex >= route.dailyRoutes.length) 
        return { 
            is_successful: false, 
            reason: 'Día fuera de rango' 
        };

    return { 
        is_successful: true, 
    };
}

export function isNotSuccess(result){
    return result.is_successful === false;
}